// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"bcn_a bhe_b bhe_tu bhe_qz bhe_ra bhe_uo","PanelFooter--link":"bcn_b"};